import { useEffect } from "react";

import { usePageRouting } from "../../hooks/usePageRouting";

type LandingPageProps = {};

/**
 * Immediately routes the Car Owner to the first actual page of the flow.
 *
 * This supports the first page of the flow being dynamic (since the WelcomePage
 * became optional).
 *
 * The Car Owner will always land on `/:sessionId` and then be immediately
 * redirected to the first page. E.g. `/:sessionId/welcome` or `/:sessionId/onboarding`
 * depending on what is configured in `App.tsx`.
 */
export const LandingPage: React.FC<LandingPageProps> = () => {
  const { onNext } = usePageRouting();

  useEffect(() => {
    onNext();
  }, [onNext]);
  return null;
};
